// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1qAbz","data":"styles_data__9oK8C"};